// extracted by mini-css-extract-plugin
export default {"button":"hoverbutton_button__Kr9aU","text":"hoverbutton_text__lD2pm","icon":"hoverbutton_icon__UlJn1"};